import request from '@/utils/request'

// 查询企业生产装置列表
export function listProductionDevice(query) {
  return request({
    url: 'admin/data/productionDevice/list',
    method: 'post',
    data: query
  })
}

// 查询企业生产装置详细
export function getProductionDevice(id) {
  return request({
    url: 'admin/data/productionDevice/info/' + id,
    method: 'get'
  })
}

// 新增/修改企业生产装置
export function addProductionDevice(data) {
  return request({
    url: 'admin/data/productionDevice/saveOrUpdate',
    method: 'post',
    data: data
  })
}


// 删除企业生产装置
export function delProductionDevice(data) {
  return request({
    url: 'admin/data/productionDevice/delete',
    method: 'post',
    data
  })
}
// 查询工艺列表
export function listTechnologyCode(query) {
  return request({
    url: 'admin/data/technologyCode/list',
    method: 'post',
    data: query
  })
}
